/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_Previewalt1Inputs */

const id_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratinjau avatar`)
};

const ms_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratonton avatar`)
};

const da_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar forhåndsvisning`)
};

const de_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar-Vorschau`)
};

const en_us2_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar preview`)
};

const es_es2_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del avatar`)
};

const es_mx2_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del avatar`)
};

const fil_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview ng avatar`)
};

const fr_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu de l'avatar`)
};

const it_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima avatar`)
};

const hu_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar előnézet`)
};

const nl_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar-voorbeeld`)
};

const no_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forhåndsvisning av avatar`)
};

const pl_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podgląd awatara`)
};

const pt_br2_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualização do avatar`)
};

const pt_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização do avatar`)
};

const ro_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previzualizare avatar`)
};

const fi_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avataren esikatselu`)
};

const sv_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatarförhandsgranskning`)
};

const vi_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem trước ảnh đại diện`)
};

const tr_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar önizleme`)
};

const cs_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled avataru`)
};

const bg_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преглед на аватар`)
};

const ru_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предпросмотр аватара`)
};

const uk_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попередній перегляд аватара`)
};

const ar_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معاينة الصورة الرمزية`)
};

const hi_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवतार पूर्वावलोकन`)
};

const th_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวอย่างรูปโปรไฟล์`)
};

const ja_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アバタープレビュー`)
};

const zh_cn2_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`头像预览`)
};

const zh_hant1_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大頭貼預覽`)
};

const ko_profile_avatar_previewalt1 = /** @type {(inputs: Profile_Avatar_Previewalt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아바타 미리보기`)
};

/**
* | output |
* | --- |
* | "Avatar preview" |
*
* @param {Profile_Avatar_Previewalt1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_avatar_previewalt1 = /** @type {((inputs?: Profile_Avatar_Previewalt1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_Previewalt1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_avatar_previewalt1(inputs)
	if (locale === "ms") return ms_profile_avatar_previewalt1(inputs)
	if (locale === "da") return da_profile_avatar_previewalt1(inputs)
	if (locale === "de") return de_profile_avatar_previewalt1(inputs)
	if (locale === "en-US") return en_us2_profile_avatar_previewalt1(inputs)
	if (locale === "es-ES") return es_es2_profile_avatar_previewalt1(inputs)
	if (locale === "es-MX") return es_mx2_profile_avatar_previewalt1(inputs)
	if (locale === "fil") return fil_profile_avatar_previewalt1(inputs)
	if (locale === "fr") return fr_profile_avatar_previewalt1(inputs)
	if (locale === "it") return it_profile_avatar_previewalt1(inputs)
	if (locale === "hu") return hu_profile_avatar_previewalt1(inputs)
	if (locale === "nl") return nl_profile_avatar_previewalt1(inputs)
	if (locale === "no") return no_profile_avatar_previewalt1(inputs)
	if (locale === "pl") return pl_profile_avatar_previewalt1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_avatar_previewalt1(inputs)
	if (locale === "pt") return pt_profile_avatar_previewalt1(inputs)
	if (locale === "ro") return ro_profile_avatar_previewalt1(inputs)
	if (locale === "fi") return fi_profile_avatar_previewalt1(inputs)
	if (locale === "sv") return sv_profile_avatar_previewalt1(inputs)
	if (locale === "vi") return vi_profile_avatar_previewalt1(inputs)
	if (locale === "tr") return tr_profile_avatar_previewalt1(inputs)
	if (locale === "cs") return cs_profile_avatar_previewalt1(inputs)
	if (locale === "bg") return bg_profile_avatar_previewalt1(inputs)
	if (locale === "ru") return ru_profile_avatar_previewalt1(inputs)
	if (locale === "uk") return uk_profile_avatar_previewalt1(inputs)
	if (locale === "ar") return ar_profile_avatar_previewalt1(inputs)
	if (locale === "hi") return hi_profile_avatar_previewalt1(inputs)
	if (locale === "th") return th_profile_avatar_previewalt1(inputs)
	if (locale === "ja") return ja_profile_avatar_previewalt1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_avatar_previewalt1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_avatar_previewalt1(inputs)
	return ko_profile_avatar_previewalt1(inputs)
});
export { profile_avatar_previewalt1 as "profile.avatar.previewAlt" }